import PropTypes from 'prop-types';
import React from 'react';
import useHandleCategoryParentId from '../../hooks/useHandleCategoryParentId';

const NavFlyoutCategoryListItem = ({
  url = '',
  name = '',
  parentCatId,
}) => {
  const { setParentCatIdToLS } = useHandleCategoryParentId(parentCatId);

  return (
    <li className="category-list-item">
      <a className="category-link" href={url} onClick={setParentCatIdToLS}>
        {name}
      </a>
    </li>
  );
};

NavFlyoutCategoryListItem.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  parentCatId: PropTypes.string.isRequired,
};

export default NavFlyoutCategoryListItem;
